import React, { Component } from 'react';
import { notification } from 'antd'

const openNotificationWithIcon = (type, title, description) => {    
    notification[type]({
      message: title,
     description: description || JSON.stringify(description),
     placement: 'bottomRight'        
    });
  };

const withErrorHandler = ( WrappedComponent, axios ) => {
    
    return class extends Component {
        
        state = {      
            loading : false,                    
        }

        constructor () {   
            super()
                     
            this.reqInterceptor = axios.interceptors.request.use( req => {                                 
                this.setState( { loading : true } );
                return req;
            }, error => {             
                return Promise.reject(error)
            });

            this.resInterceptor = axios.interceptors.response.use( res => {                        
                this.setState({ loading : false})   
                return res
            }, error => {     
                    console.error(error)                                   
                    const errMessage = error.response || error                                                                                                                                
                    openNotificationWithIcon('error', 'Terjadi Kesalahan', errMessage.data.errorMessage || errMessage.data.message || errMessage.message || "Terjadi kesalahan pengisian" )                                                                                            
                    this.setState( { loading : false } ); 
                    return Promise.reject(errMessage)                                                     
            } );
        }

        componentWillUnmount () {          
            axios.interceptors.request.eject( this.reqInterceptor );
            axios.interceptors.response.eject( this.resInterceptor );
        }     

        render () {                          
            return (
                <>                                                          
                    <WrappedComponent {...this.props} loading={this.state.loading} />                    
                </>
            );
        }
    }
}

export default withErrorHandler;